import { WidgetConfig } from '../../../models/widget.config';

export class GridGroupWidgetConfig extends WidgetConfig<unknown> {
  controlType = 'FormGroup';
  widgetType = 'GridGroupWidget';
  constructor(config = {}) {
    super(config);
  }
}
